import WishlistContainer from "../../../components/applications/eCommerce/wishList";

const WishList = () => {
  return <WishlistContainer />;
};

export default WishList;
